import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        header: {
            display: 'flex',
            width: '100%',
            justifyContent: 'flex-end',
        },
    }
})

export default useStyles
